<template>
    <div>
        <b-card :header="uLang('app.create')" header-tag="h4" class="bg-default-card">
            <trajectory-form v-if="project" :project="project" :overrideEndpoint="overrideEndpoint"/>
        </b-card>
    </div>
</template>

<script>
    import TrajectoryForm from '~/components/forms/admin/projects/trajectory/form'

    export default {
        name: 'create',

        props: {
            projectId: {
                required: true,
            }
        },

        components: {
            'trajectory-form': TrajectoryForm,
        },

        data() {
            return {
                project: undefined,
            };
        },

        created() {
            this.retrieveProject();
        },

        methods: {
            async retrieveProject() {
                const {data} = await window.axios.get(route('trajectory-projects.show', { trajectory_project: this.projectId }));
                this.project = data;
            },
        },

        computed: {
            overrideEndpoint() {
                return route('trajectory-projects.trajectories.store', { trajectory_project: this.projectId })
            }
        },
    }
</script>

<style lang="css" scoped>
</style>
